export default __webpack_public_path__ + "static/media/doctor-1.0b3532e5.jpg";